export enum ChatSideEnum {
    USER = "user",
    AI = "ai"
}

export enum AppCompaniesChoices {
    "alfa-bank" = "alfa-bank",
    "vsk" = "vsk",
    "h" = "h",
    "vtb" = "vtb",
    "robo-finance" = "robo-finance",
    "x-5" = "x-5",
    "sport-master" = "sport-master",
    "ar" = "ar",
    "kontur" = "kontur",
}

export type MidGameConfiguration = {
    heading: string
    description: string
    button: {
        text: string
        link: string
    } | null
    image: string
}

export type MidGameCompanies = "final" | AppCompaniesChoices | null

export type ModificatorObject = {
    decision: boolean,
    name: string
}

export type Modificators =
    Array<string
        | number
        | boolean
        | ModificatorObject>